'use strict';exports.__esModule = true;exports.default = {
  geolocate: function geolocate() {var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res, rej) {
      if (!__CLIENT__ || __CLIENT__ && !('geolocation' in navigator)) {
        rej(new Error('Not supported'));
      }

      navigator.geolocation.getCurrentPosition(function (_ref) {var coords = _ref.coords;return res({
          lat: coords.latitude,
          lng: coords.longitude });},
      function (error) {return rej(error);}, opts);
    });
  } };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/services/GeolocationService.js
// module id = 3097
// module chunks = 0